/**
 * QS Regalos (Quality Sport)
 * Agrega o quita automaticamente la "Camisa misteriosa (Regalo)" segun el subtotal del carrito.
 * El precio $0 lo pone el descuento automatico "Regalo camisa misteriosa desde $450.000".
 * Se ejecuta con los eventos nativos del carrito de Horizon (sin setInterval).
 */
import { CartLinesUpdateEvent, StandardEvents } from '@shopify/events';

const GIFT_VARIANT_ID = 52862402494695;
const GIFT_THRESHOLD = 45000000; // $450.000 en centavos (sin contar el regalo)
const SOURCE = 'qs-regalos';
const ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

let running = false;
let queued = false;

function getSectionIds() {
  return [...document.querySelectorAll('cart-items-component')]
    .map((el) => el.dataset.sectionId)
    .filter(Boolean);
}

async function getCart() {
  const res = await fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } });
  return res.json();
}

async function postJSON(path, body) {
  const res = await fetch(ROOT + path, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify(body),
  });
  return res.json();
}

function announce(action, lines, cart, sections) {
  const deferred = CartLinesUpdateEvent.createPromise();
  document.dispatchEvent(
    new CartLinesUpdateEvent({ action, context: SOURCE, lines, promise: deferred.promise })
  );
  deferred.resolve({
    cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
    detail: { source: SOURCE, items: cart.items, itemCount: cart.item_count, sections },
  });
}

async function reconcile() {
  if (running) {
    queued = true;
    return;
  }
  running = true;
  try {
    const cart = await getCart();
    const giftLines = cart.items.filter((item) => item.variant_id === GIFT_VARIANT_ID);
    const subtotal = cart.items
      .filter((item) => item.variant_id !== GIFT_VARIANT_ID && !(item.line_level_discount_allocations || []).length)
      .reduce((sum, item) => sum + item.final_line_price, 0);
    const sections = getSectionIds();

    if (subtotal >= GIFT_THRESHOLD) {
      if (giftLines.length === 0) {
        const added = await postJSON('cart/add.js', {
          items: [{ id: GIFT_VARIANT_ID, quantity: 1 }],
          sections,
        });
        const updatedCart = await getCart();
        announce('add', [{ merchandiseId: GIFT_VARIANT_ID, quantity: 1 }], updatedCart, added.sections);
      } else if (giftLines.length > 1 || giftLines[0].quantity !== 1) {
        const updates = {};
        giftLines.forEach((line, index) => {
          updates[line.key] = index === 0 ? 1 : 0;
        });
        const updatedCart = await postJSON('cart/update.js', { updates, sections });
        announce(
          'update',
          giftLines.map((line, index) => ({ id: line.key, quantity: index === 0 ? 1 : 0 })),
          updatedCart,
          updatedCart.sections
        );
      }
    } else if (giftLines.length > 0) {
      const updates = {};
      giftLines.forEach((line) => {
        updates[line.key] = 0;
      });
      const updatedCart = await postJSON('cart/update.js', { updates, sections });
      announce(
        'update',
        giftLines.map((line) => ({ id: line.key, quantity: 0 })),
        updatedCart,
        updatedCart.sections
      );
    }
  } catch (error) {
    console.warn('[qs-regalos]', error);
  } finally {
    running = false;
    if (queued) {
      queued = false;
      reconcile();
    }
  }
}

function onCartChange(event) {
  if (event.context === SOURCE) return;
  Promise.resolve(event.promise)
    .then(() => reconcile())
    .catch(() => {});
}

document.addEventListener(StandardEvents.cartLinesUpdate, onCartChange);
document.addEventListener(StandardEvents.cartDiscountUpdate, onCartChange);
reconcile();
